import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { ModalController, ToastController } from '@ionic/angular';
import { async } from 'rxjs';
import { data } from 'src/app/audit-trail/application/data';
import { ViewPdfComponent } from '../view-pdf/view-pdf.component';

@Component({
  selector: 'app-secure-confirm-data-modal',
  templateUrl: './confirm-data-modal.component.html'
})
export class ConfirmDataModalComponent implements OnInit {
  fileUploadForm: FormGroup = new FormGroup({});
  modalHeader: string;
  fileType: string;
  base64: any;
  nomineeDocBase64: any;
  selectedFile: File;
  isSubmitDisabled: boolean = false;
  nomineeRelationWthApp: string;
  nomineePanNumber:string;
  nomineeAge: string;
  nomineeGender: string;
  nomineeName: string;

  constructor(private modalCtrl: ModalController, private toastController: ToastController) { }

  ngOnInit(): void { 
    
  }

  async showFile() {
    const base64Data = this.base64.split(",")[1];
    if(this.base64 != null) {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: base64Data,
          documentName: "Nominee Application Transfer Order File",
          fileName: "ORDERFILE_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.showErrorToast("Upload File Again");
    }
  }

  async showFile2() {
    const base64Data = this.nomineeDocBase64.split(",")[1];
    if(this.nomineeDocBase64 != null) {
      const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
        componentProps: {
          base64: base64Data,
          documentName: "Nominee Documents File",
          fileName: "NOMINEEDOCFILE_"+new Date().getTime()+".pdf"
        }
      });
      modal.present();
    }
    else {
      this.showErrorToast("Upload File Again");
    }
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  upload() {
    if (!this.selectedFile){
       this.showErrorToast("Please Upload the File");
    }
     
    if (!this.base64){
      this.showErrorToast("Please Upload the File");
    }

    if (this.base64) {
      return this.modalCtrl.dismiss(this.base64);
    }
    else {
      
    }
  }

  submit(){
    console.log("Save call");
    return this.modalCtrl.dismiss(
      "Submit"
    );
  }
  
  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public space(event:any){

    if (event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
  }

}
